import "./Login.css";

import { useRef, useState } from "react";

import { useUnleashContext } from "@unleash/proxy-client-react";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { useSignIn } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import logo from "../abe_logo.png";
import { PAGES } from "../constants";

function Login() {
  const navigate = useNavigate();
  const signIn = useSignIn();
  const updateContext = useUnleashContext();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");

  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const emailRef = useRef(null);
  const passwordRef = useRef(null);

  const handleLogin = async (event) => {
    event.preventDefault();

    // Get token from API
    const tokenUrl = `${process.env.REACT_APP_BASE_URL}/user/login`;
    const tokenData = {
      username: email,
      password: password
    };
    const tokenConfig = {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    };
    axios.post(tokenUrl, tokenData, tokenConfig)
      .then(response => {
        const jwtDecoded = jwt_decode(response.data.access_token);
        const expiryEpoch = jwtDecoded.exp; // Expiry epoch in seconds
        const currentEpoch = (new Date()).getTime() / 1000; // Current epoch in seconds
        const expiresIn = Math.ceil((expiryEpoch - currentEpoch) / 60) // Amount of minutes until expiry
        if (signIn(
          {
            token: response.data.access_token,
            expiresIn: Math.max(expiresIn, 0), // Ensure expiresIn is not negative
            tokenType: response.data.token_type,
            authState: { email: jwtDecoded.sub }
          }
        )) {
          updateContext({ userId: jwtDecoded.sub });
          navigate(PAGES.HOME, { state: { showHelp: true } });
        }
      })
      .catch(error => {
        if (error.response) {
          if (typeof error.response.data.detail === "string") {
            setLoginError(error.response.data.detail);
          } else if (Array.isArray(error.response.data.detail)) {
            error.response.data.detail.forEach(detail => {
              if (detail.loc[1] === "username") {
                setEmailError(detail.msg);
              } else if (detail.loc[1] === "password") {
                setPasswordError(detail.msg);
              }
            });
          } else {
            setLoginError("Something went wrong, please try again later");
          }
        } else {
          setLoginError("Unable to connect to server");
        }
      });
  }

  const handleBackButton = () => {
    navigate(PAGES.AUTH);
  }

  const handleForgotPassword = () => {
    navigate(PAGES.AUTH_PASSWORD_RESET);
  }

  const setInputs = () => {
    setEmail(emailRef.current.value);
    setPassword(passwordRef.current.value);

    // Update error messages to be empty if the relevant input field is updated
    if (emailRef.current.value !== "") setEmailError("");
    if (passwordRef.current.value !== "") setPasswordError("");
  }

  return (
    <div className="login-container" data-testid="login-page-div">
      <img src={logo} className="logo" alt="logo" />

      <form onSubmit={handleLogin}>
        <input className="auth-input" type="text" placeholder="Email" ref={emailRef} onChange={setInputs} />
        <p className="auth-input-error-text">{emailError}</p>

        <input className="auth-input" type="password" placeholder="Password" ref={passwordRef} onChange={setInputs} />
        <p className="auth-input-error-text">{passwordError}</p>

        <div className="auth-center-contents">
          {loginError !== "" && <p className="error-message">{loginError}</p>}
          <input type="submit" className="auth-button" value="Login" />
        </div>
      </form>

      <div className="login-hyperlinks-container">
        <p className="login-hyperlinks" onClick={handleBackButton}>Go back to sign up</p>
        <p className="login-hyperlinks" onClick={handleForgotPassword}>Forgot password?</p>
      </div>
    </div>
  );
}

export default Login;
